module.exports = __webpack_public_path__ + "img/ic-hacer-pedido.6d381212.png";